import { Component, OnInit, Input, Output, HostListener, ElementRef, ViewChild, EventEmitter, Renderer2 } from '@angular/core';
import { Router } from '@angular/router';
import { AlertController, AnimationController, LoadingController, ModalController } from '@ionic/angular';
import { DataService } from 'src/app/services/data.service';

@Component({
  selector: 'app-list-view',
  templateUrl: './list-view.component.html',
  styleUrls: ['./list-view.component.scss'],
})

export class ListViewComponent  implements OnInit {

 //  @Input() offer_details;
 @Input() type;
 @Input() no_products;
 @Input() array_values;
 @Output() list_click = new EventEmitter();
 @Output() pagination = new EventEmitter();
 @ViewChild('showme') showme !: ElementRef;
 @ViewChild('#mymenu') mymenu !: ElementRef;

 page_no = 1;
 page_length = 10;
 navigation = true;
 recruiter_data = [];
 sort_by = '';
 //  recruiter_offer_details;
 visible_true;
 mouseclick;
 tabs_array:any = [];
 status;
 isActive: any;
 all_link_opts: any;
 offers_title:any = [];
//  no_products = false;

 constructor(private render: Renderer2, public modalctrl: ModalController,private loadingCtrl:LoadingController, private alertCtrl: AlertController, public db: DataService, public router: Router, public modalCtrl: ModalController, private animationCtrl: AnimationController) { }


 ngOnInit() {

  
   if (this.type == 'product') {
     this.offers_title = [{ 'name': 'Product Name', 'flex': '30%' }, { 'name': 'Attribute', 'flex': '21%' }, { 'name': 'Product Id', 'flex': '14%' }, { 'name': 'SKU', 'flex': '13%' }, { 'name': 'Price', 'flex': '13%' },{ 'name': '', 'flex': '9%' }];
   }
 }

 ngAfterViewInit(): void {

 }

 options = [{ option: 'Any' }, { option: 'Awaiting Response' }, { option: 'Job Expired' }, { option: 'Hired' }, { option: 'Not Hired' }, { option: 'Interviewing' }, { option: 'Archived' },]
 options1 = [{ option: 'Name: A-Z', 'name': 'ASC' }, { option: 'Name: Z-A', 'name': 'DESC' }]


 loadData(event) {
   // console.log(event)
   if(event.target.offsetHeight + event.target.scrollTop >= event.target.scrollHeight){
     this.pagination.emit();
   } 
 }


 // ion-model slide left transaction
 enterAnimation = (baseEl: HTMLElement) => {
   var root:any = baseEl.shadowRoot;
   const backdropAnimation = this.animationCtrl
     .create()
     .addElement(root.querySelector('ion-backdrop')!)
     .fromTo('opacity', '0.01', 'var(--backdrop-opacity)');

   const wrapperAnimation = this.animationCtrl
     .create()
     .addElement(root.querySelector('.modal-wrapper')!)
     .keyframes([
       { offset: 0, opacity: '0.09', transform: 'translateX(100%)' },
       { offset: 1, opacity: '1', transform: 'translateX(0)' },
     ]);
   return this.animationCtrl
     .create()
     .addElement(baseEl)
     .easing('ease-out')
     .duration(500)
     .addAnimation([backdropAnimation, wrapperAnimation]);
 };
 leaveAnimation = (baseEl: HTMLElement) => {
   return this.enterAnimation(baseEl).direction('reverse');
 };


}

